module.exports = __webpack_public_path__ + "static/baby-hichair-11134b0887844742820e35b0b1fde3c2.jpeg";